<button [class]="buttonClass"
    [disabled]="disabled"
    (click)="toggleFilter($event)"
    [tooltipDisabled]="!buttonWithTextMenu.showTooltip"
    [pTooltip]="'common.copied' | afTranslate"
    tooltipPosition="top"
    tooltipEvent="focus">
    @if(icon){
      <i [class]="'common-icon__md ' + icon"></i>
    }
    <span-tooltip class="common-button__text-title"
      [text]="textButton | afTranslate"></span-tooltip>
    <!-- <span class="common-button__text-title"
      [afTranslate]="textButton">_Texto del boton</span> -->
</button>
<p-overlayPanel
  #overlayPanelTextMenu
  styleClass="common-dropdown-overlay__container-button">
  <ng-template pTemplate="content">
    @if(item.expandedMenu?.length > 5){
      <div class="common-search__container-tonal">
        <div class="common-search__container-input-text">
          <input
            type="search"
            class="common-search__input-text"
            pAutoFocus
            [autofocus]="true"
            [(ngModel)]="buttonWithTextMenu.inputFilter"
            placeholder="{{'common.search-item' | afTranslate}}">
        </div>
        <div class="common-search__block-button-search">
          @if(buttonWithTextMenu.inputFilter){
            <button class="common-button__icon-xs-noborder"
              (click)="resetFilter()">
              <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
          }
          <div class="h-[22px]"
            ngClass="{{buttonWithTextMenu.inputFilter?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}">
          </div>
          <i class="lf-icon-search common-icon__md"
            ngClass="{{!buttonWithTextMenu.inputFilter ? 'common-search__icon-search-disabled' : 'common-search__icon-search-enabled'}}">
          </i>
        </div>
      </div>
    }
    <div class="common-dropdown__items-container">
      @for (optionAction of item.expandedMenu | byWord:buttonWithTextMenu.inputFilter:['name'] | afOrderBy:[item.orderBy]:false; track $index) {
        <button class="common-dropdown-list__si-button"
          (click)="launchAction(optionAction.action, optionAction)"
          [disabled]="optionAction.disabled">
          @if(optionAction.icon){
            <i [class]="optionAction.icon + ' common-icon__md'"></i>
          }
          <span-tooltip class="common-dropdown-list__si-text-container"
            [text]="optionAction.name | afTranslate"
            [tooltipPosition]="'top'"
            [multiline]="multiline"></span-tooltip>
        </button>
      }@empty {
        <span class="common-empty-state__searched-text"
          [afTranslate]="'common.without-results'">
          _Sin resultados
        </span>
      }
    </div>
  </ng-template>
</p-overlayPanel>
